// PageLayout.js
import React from "react";

function PageLayout({ children }) {
    return (
        <div className="font-suit font-[800] w-screen h-screen relative overflow-hidden bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex flex-col">
            {/* Radial Gradient 효과 추가 */}
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-purple-900/20 via-slate-900/50 to-slate-900"></div>

            {/* 배경 블러 효과 */}
            <div className="absolute -top-[20%] -left-[10%] w-[600px] h-[600px] rounded-full bg-blue-600/30 blur-[150px] pointer-events-none"></div>
            <div className="absolute -bottom-[20%] -right-[10%] w-[700px] h-[700px] rounded-full bg-purple-500/40 blur-[180px] pointer-events-none"></div>
            <div className="absolute top-[20%] right-[10%] w-[400px] h-[400px] rounded-full bg-fuchsia-500/20 blur-[120px] pointer-events-none"></div>

            {/* Floating Shapes */}
            <div className="absolute inset-0 pointer-events-none z-[1]">
                {/* Circle */}
                <div className="absolute top-[15%] left-[10%] w-[100px] h-[100px] rounded-full bg-gradient-to-br from-blue-500 to-purple-600 opacity-20 shadow-[0_0_30px_rgba(59,130,246,0.3)] animate-[float_20s_ease-in-out_infinite]"></div>

                {/* Square */}
                <div className="absolute top-[60%] right-[15%] w-[80px] h-[80px] bg-gradient-to-br from-pink-500 to-purple-600 opacity-20 rotate-45 shadow-[0_0_30px_rgba(236,72,153,0.3)] animate-[float_20s_ease-in-out_infinite] [animation-delay:-5s]"></div>

                {/* Triangle */}
                <div className="absolute bottom-[20%] left-[20%] w-0 h-0 opacity-20 border-l-[50px] border-l-transparent border-r-[50px] border-r-transparent border-b-[90px] border-b-cyan-400/40 drop-shadow-[0_0_20px_rgba(34,211,238,0.3)] animate-[float_20s_ease-in-out_infinite] [animation-delay:-10s]"></div>
            </div>

            {children}

            <style>{`
                @keyframes float {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg);
                    }
                    50% {
                        transform: translateY(-30px) rotate(180deg);
                    }
                }
            `}</style>
        </div>
    );
}

export default PageLayout;
